<template>
  <div>
    <div v-if="activeView === 'gallery'">
      <div
        class="col-md-12 text-left"
        style="flex-wrap: wrap; margin-bottom: 10px"
      >
        <btn-rounded
          class="text-left"
          :label="'ADICIONAR'"
          event="newPhoto"
          :active-color="'success'"
        />
      </div>
      <div style="display: none">
        <input
          ref="newImageInput"
          type="file"
          @change="onFileChange"
          style="display: none"
          accept="image/*"
        />

        <div
          class="col-md-1 choose_file"
          style="padding-left: 0px; display: none;"
          v-if="fileType == ''"
        >
          <span
            class="ti-clip"
            style="font-size: 36px; vertical-align: middle;"
          />
          <input ref="image" type="file" @change="onFileChange" />
        </div>
      </div>
      <carousel-3d
        :count="data.CarImages.length"
        :controls-visible="true"
        :width="1200"
        :height="1000"
        :controlsNextHtml="controlsNextHtml"
        :controlsPrevHtml="controlsPrevHtml"
      >
        <slide
          v-for="(slide, i) in data.CarImages"
          :index="i"
          :key="i"
          style="border: none;"
        >
          <template
            slot-scope="{ index, isCurrent, leftIndex, rightIndex }"
          >
            <img
              @click="openEditor(index)"
              :data-index="index"
              :class="{
                onLeft: leftIndex >= 0,
                onRight: rightIndex >= 0,
              }"
              :src="slide.imageURL"
              style="width: 100%; height: 100%; object-fit: contain;background-color:#F4F3EE"
            />
          </template>
        </slide>
      </carousel-3d>
    </div>

    <form>
      <!-- ///responsável -->
      <div v-if="activeView === 'profile'" class="">
        <div class="row">
          <div class="col-md-2">
            <fg-select
              label="Estado"
              :options="StateList"
              v-model="data.UF"
              :selected="data.UF"
              v-bind:readonly="true"
              :change="onChange()"
            />
          </div>
          <div class="col-md-2">
            <fg-input
              class="clean"
              type="text"
              label="Marca"
              placeholder="Marca"
              v-model="data.manufacturer"
              v-bind:readonly="true"
            />
          </div>

          <div class="col-md-2">
            <fg-input
              class="clean"
              type="text"
              label="Modelo"
              placeholder="Modelo"
              v-model="data.modell"
              v-bind:readonly="true"
            />
          </div>

          <div class="col-md-1">
            <fg-input
              class="clean"
              type="text"
              label="Ano"
              placeholder="Ano"
              v-model="data.year"
              v-bind:readonly="true"
            />
          </div>

          <div class="col-md-3">
            <fg-input
              class="clean"
              type="text"
              label="Versão"
              placeholder="Versão"
              v-model="data.version"
              v-bind:readonly="true"
            />
          </div>

          <div class="col-md-2">
            <fg-input
              class="clean"
              type="text"
              label="Quilometragem/Km"
              placeholder="Km"
              v-model="data.mileage"
              v-bind:readonly="true"
            />
          </div>

          <div class="col-md-1">
            <fg-input
              class="clean"
              type="text"
              label="Conservação"
              placeholder="Conservação"
              v-model="data.conservationState"
              v-bind:readonly="true"
            />
          </div>

          <div class="col-md-2">
            <fg-input
              class="clean"
              type="text"
              label="Categoria"
              placeholder="Carros"
              v-model="data.Category.name"
              v-bind:readonly="true"
            />
          </div>

          <div class="col-md-2">
            <fg-select
              label="Cor"
              :options="colorsList"
              v-model="data.ColorId"
              :selected="data.ColorId"
              v-bind:readonly="readonly"
            />
          </div>

          <div class="col-md-2">
            <fg-select
              label="Combustível"
              :options="typefuelList"
              v-model="data.TypeFuelId"
              :selected="data.TypeFuelId"
              v-bind:readonly="readonly"
            />
          </div>

          <div class="col-md-2">
            <fg-input
              class="clean"
              type="text"
              label="Placa"
              placeholder="Placa"
              v-model="data.plate"
              v-bind:readonly="readonly"
            />
          </div>

          <div class="col-md-3">
            <fg-input
              class="clean"
              type="text"
              label="Valor para Venda"
              placeholder="Valor"
              v-on:input="format"
              v-model="data.formattedDesiredValueCentavos"
              v-bind:readonly="readonly"
            />
          </div>

          <div class="col-md-4">
            <fg-textarea
              class="clean"
              type="text"
              label="Descrição"
              v-model="data.description"
              v-bind:readonly="readonly"
            />
          </div>
        </div>
      </div>
    </form>
    <div v-if="plate" class="edit-modal">
      <btn-rounded
        class="btnSaveImage"
        label="SALVAR"
        event="saveImages"
        active-color="success"
      />
      <btn-rounded
        class="btnCancelImage"
        label="CANCELAR"
        event="close"
        active-color="warning"
      />

      <btn-rounded
        class="btnDeleteImage"
        label="APAGAR"
        event="deleteImage"
        active-color="danger"
      />

      <div class="arrow-container">
        <div class="fa fa-mail-forward"></div>
      </div>

      <div class="instructions">
        <p>
          Por favor, cubra a placa do veículo arrastando a imagem abaixo.
        </p>
      </div>

      <div>
        <div class="logo logo-container" ref="logoContainer">
          <img class="logoResize" src="/static/img/carrocash.png" alt="Logo" />
        </div>
        <div class="image-container" ref="imageContainer">
          <img class="image" crossorigin="anonymous" :src="tempImageURL" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import moment from "moment";
import formGroupImage from "src/components/UIComponents/Inputs/formGroupImage.vue";
import { NAMES } from "../../../config";
import api from "../../../api";
import { getCookie } from "src/utils/authService";
import interact from "interactjs";
import Vue from "vue";

import { Carousel3d, Slide } from "vue-carousel-3d";

Vue.use(Carousel3d);

export default {
  name: "mining-form",
  components: {
    formGroupImage,
    Carousel3d,
    Slide,
  },


  props: {
    data: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    event: {
      type: String,
      default: "",
    },
    activeView: {
      type: String,
      default: "profile",
    },
    url: {
      type: String,
      default: NAMES.fullUrl,
    },
  },

  computed: {
    ...mapState({
      operatorList: ({ operator }) =>
        operator.list.map((obj) => {
          return { name: obj.name, value: obj.id };
        }),
      colorsList: ({ colors }) =>
        colors.list.map((obj) => {
          return {
            name: obj.name,
            value: obj.id,
          };
        }),

      typefuelList: ({ typefuel }) =>
        typefuel.list.map((obj) => {
          return {
            name: obj.name,
            value: obj.id,
          };
        }),
    }),
  },

  // watch: {
  //   // value: function (val) {
  //   //   console.log(val)
  //   //   this.editingIndex = val;
  //   // }
  // },

  methods: {
    ...mapActions(["getMaterialList", "getColorsList", "getTypeFuelList"]),
    ...mapGetters({
      sidebarFlag: "sidebarFlag",
    }),

    triggerFileInput() {
      this.editingIndex = null
      this.$refs.newImageInput.click();
    },
    onFileChange(event) {
      const files = event.target.files;
      if (!files.length) return;

      this.formD = new FormData();
      this.fileName = files[0].name;
      this.formD.append("file", files[0]);
      this.ready = true;

      const reader = new FileReader();
      reader.onload = (e) => {
        this.tempImageURL = e.target.result;
        var type = e.target.result.split(";");
        if (type[0].includes("image")) {
          this.fileType = "image";
        } else if (type[0].includes("video")) {
          this.fileType = "video";
        } else if (type[0].includes("audio")) {
          this.fileType = "audio";
        } else {
          this.fileType = "document";
        }
      };

      reader.readAsDataURL(files[0]);
      this.openEditor();
    },

    saveImage() {
      api.startLoader();
      let CarId = this.data.id;
      let url = this.url + "car/image/new";
      const formData = new FormData();

      if (this.editingIndex !== null) {
        formData.append(
          "CarImageId",
          this.data.CarImages[this.editingIndex].id
        );
      } else {
        formData.append("CarId", CarId);
      }

      const image = this.$refs.imageContainer.querySelector(".image");
      const logo = this.$refs.logoContainer;

      const canvas = document.createElement("canvas");
      canvas.width = image.naturalWidth;
      canvas.height = image.naturalHeight;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight);

      const logoRect = logo.getBoundingClientRect();
      const containerRect = this.$refs.imageContainer.getBoundingClientRect();

      const scaleX = image.naturalWidth / containerRect.width;
      const scaleY = image.naturalHeight / containerRect.height;

      const x = (logoRect.left - containerRect.left) * scaleX;
      const y = (logoRect.top - containerRect.top) * scaleY;
      const logoWidth = logoRect.width * scaleX;
      const logoHeight = logoRect.height * scaleY;

      ctx.drawImage(logo.querySelector("img"), x, y, logoWidth, logoHeight);

      canvas.toBlob((blob) => {
        const fileNameWithoutExtension = this.fileName
          .split(".")
          .slice(0, -1)
          .join(".");
        const fullFileName = `${fileNameWithoutExtension} - cobreplaca.png`;

        formData.append("file", blob, fullFileName);

        const request = new XMLHttpRequest();
        request.open("POST", url);
        request.setRequestHeader(
          "security-token",
          getCookie("token").replace(/(^")|("$)/g, "")
        );

        request.onreadystatechange = () => {
          if (request.readyState === 4) {
            if (request.status === 201) {
              const response = JSON.parse(request.responseText);

              this.data.CarImages = response.$success.info.CarImages

              this.$parent.$emit("updateData", response.$success.info);

              this.editingIndex = null;
              this.plate = false;
            } else {
              console.error("Failed to save image.");
            }
            api.stopLoader();
          }
        };

        request.send(formData);
      }, "image/png");
    },

    openEditor(index) {
      this.plate = true;
      if (index !== undefined) {
        this.editingIndex = index;
        this.tempImageURL = this.data.CarImages[index].imageURL;
      }


      interact(".logo")
        .draggable({
          listeners: {
            move: (event) => {
              const target = event.target;
              const x =
                (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
              const y =
                (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;

              // Atualize a posição do logotipo
              target.style.transform = `translate(${x}px, ${y}px)`;

              // Atualize os atributos de dados para manter o rastreamento da posição
              target.setAttribute("data-x", x);
              target.setAttribute("data-y", y);
            },
          },
        })
        // .resizable({
        //   edges: { left: true, right: true, bottom: true, top: true },
        //   listeners: {
        //     move: (event) => {
        //       const target = event.target;
        //       const x = parseFloat(target.getAttribute("data-x")) || 0;
        //       const y = parseFloat(target.getAttribute("data-y")) || 0;

        //       // Atualize o tamanho do logotipo
        //       target.style.width = `${event.rect.width}px`;
        //       target.style.height = `${event.rect.height}px`;

        //       // Atualize os atributos de dados para manter o rastreamento do tamanho
        //       target.setAttribute("data-x", x);
        //       target.setAttribute("data-y", y);
        //     },
        //   },
        // });
    },



    onChange() {
      for (var i = 0; i < this.StateList.length; i++) {
        if (this.data.UF == this.StateList[i].value) {
          this.data.locationState = this.StateList[i].name;
        }
      }
    },

    unlock() {
      if (this.sidebarFlag() === "ADMIN") {
        this.localReadonly = !this.localReadonly;
      } else {
        this.localReadonly = true;
      }
    },

    openImageModal(images) {
      this.modalImages = images; // Define as imagens para exibir no modal
      this.$bvModal.show("image-modal");
    },

    formatDate(date) {
      return moment
        .utc(date)
        .utcOffset(-180)
        .format("D/M/YYYY H:mm:ss");
    },

    format: function(sValue) {
      this.data.formattedDesiredValueCentavos = parseInt(
        ("" + sValue).onlyNumber()
      ).int2Money();

      this.data.desiredValueCentavos = this.data.formattedDesiredValueCentavos
        .replace("R$", "")
        .replace(",", "")
        .replace(".", "")
        .replace(" ", "");

      this.$nextTick(() => {});
    },
  },

  created() {
    this.getColorsList();
    this.getTypeFuelList();

    this.$on("execute", () => {
      this.$parent.$emit(this.event, this.data);
    });

    this.$on("saveImages", () => {
      this.saveImage();
    });

    this.$on("deleteImage", () => {
      let send = {
        CarImageId: this.data.CarImages[this.editingIndex].id,
        id: this.data.id
      }
      this.$parent.$emit("deleteImages", send);
      this.plate = false;
      this.editingIndex = null;
    });

    this.$on("close", () => {
      this.plate = false;
      this.editingIndex = null;
    });

    this.$on("newPhoto", () => {
      this.triggerFileInput();
    });
  },
  data() {
    return {
      localReadonly: false,
      editingIndex: null,
      tempImageURL: null,
      plate: false,
      fileType: "",
      fileName: "",
      formD: null,
      ready: false,
      lValue: null,
      controlsNextHtml:
        '<div style="color: green; font-size: 24px;">&#9654;</div>',
      controlsPrevHtml:
        '<div style="color: green; font-size: 24px;">&#9664;</div>',
      colors: [],
      isPerfect: [
        {
          value: true,
          name: "Sim",
        },
        {
          value: false,
          name: "Não",
        },
      ],

      oldCep: "",
      StateList: [
        {
          value: "AC",
          name: "Acre",
        },
        {
          value: "AL",
          name: "Alagoas",
        },
        {
          value: "AP",
          name: "Amapá",
        },
        {
          value: "AM",
          name: "Amazonas",
        },
        {
          value: "BA",
          name: "Bahia",
        },
        {
          value: "CE",
          name: "Ceará",
        },
        {
          value: "DF",
          name: "Distrito Federal",
        },
        {
          value: "ES",
          name: "Espirito Santo",
        },
        {
          value: "GO",
          name: "Goiás",
        },
        {
          value: "MA",
          name: "Maranhão",
        },
        {
          value: "MT",
          name: "Mato Grosso",
        },
        {
          value: "MS",
          name: "Mato Grosso do Sul",
        },
        {
          value: "MG",
          name: "Minas Gerais",
        },
        {
          value: "PA",
          name: "Pará",
        },
        {
          value: "PB",
          name: "Paraíba",
        },
        {
          value: "PR",
          name: "Paraná",
        },
        {
          value: "PE",
          name: "Pernambuco",
        },
        {
          value: "PI",
          name: "Piauí",
        },
        {
          value: "RJ",
          name: "Rio de Janeiro",
        },
        {
          value: "RN",
          name: "Rio Grande do Norte",
        },
        {
          value: "RS",
          name: "Rio Grande do Sul",
        },
        {
          value: "RO",
          name: "Rondônia",
        },
        {
          value: "RR",
          name: "Roraima",
        },
        {
          value: "SC",
          name: "Santa Catarina",
        },
        {
          value: "SP",
          name: "São Paulo",
        },
        {
          value: "SE",
          name: "Sergipe",
        },
        {
          value: "TO",
          name: "Tocantins",
        },
      ],
    };
  },
};
</script>
<style scoped lang="scss">
label.stronger {
  font-weight: bold;
  color: black;
}

.stronger {
  font-weight: bold;
  color: black;
  margin: 15px 0 0 0 !important;
}

p.subject {
  color: #9c9c9c;
}
.edit-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.image-container {
  height: 800px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
}

.image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.logo-container {
  position: absolute;
  top: 0;
  left: 0;
  background-color: transparent;
  cursor: move;
  z-index: 2;
}

.logo {
  position: absolute;
  top: 82px;
  left: 18%;
  width: 100px;
  cursor: move;
}

.logoResize {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.btnSaveImage {
  position: absolute;
  top: 20px;
  right: 305px;
  z-index: 2;
}

.btnCancelImage {
  position: absolute;
  top: 20px;
  right: 160px;
  z-index: 2;
}

.btnDeleteImage {
  position: absolute;
    top: 20px;
    right: 15px;
    z-index: 2;
}

.instructions {
  font-size: 36px;
  color: white;
  background-color: rgba(0, 0, 0, 0.7);
  padding-left: 8px;
  padding-right: 8px;
  font-weight: 600;
  text-align: center;
  position: absolute;
  top: 35px;
  left: 12%;
  z-index: 2;
}

.arrow-container {
  position: absolute;
  top: 60px;
  left: 12%;
  z-index: 3;
  font-size: 50px;
  color: green;
  transform: scaleY(-1.4);
}

.arrow {
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 30px solid green;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/MiningForm.vue